const canUseDOM = typeof document !== "undefined";

// eslint-disable-next-line import/no-mutable-exports
export const initDigitalDataObject = (country = "US", geoRegion = "US") => ({
  page: {
    pageInfo: {
      country,
      geoRegion,
    },
    attributes: {
      internalSearch: {
        term: "",
        results: "",
      },
    },
    category: {
      pageType: "",
    },
  },
  user: [
    {
      userState: "guest",
      segment: { activeMember: false },
    },
  ],
  cart: {},
  product: [],
});

let digitalData = initDigitalDataObject();

if (canUseDOM) {
  window.digitalData = window.digitalData || digitalData;
  // eslint-disable-next-line prefer-destructuring
  digitalData = window.digitalData;
}

export class DigitalData {
  constructor(data) {
    this.data = data || digitalData;
  }

  setGlobalData({ country, geoRegion, language, currency }) {
    if (!canUseDOM) {
      return;
    }

    Object.assign(this.data.page.pageInfo, {
      country,
      geoRegion,
      language,
      currency,
    });
  }

  setPageData({ pageID, pageName, pageType, gender }) {
    if (!canUseDOM) {
      return;
    }

    Object.assign(this.data.page.pageInfo, {
      pageID,
      pageName,
      pageType,
      gender,
    });
  }

  setUserData({ userState, activeMember }) {
    if (!canUseDOM) {
      return;
    }

    Object.assign(this.data.user[0], {
      userState,
      segment: { activeMember },
    });
  }
}

export default new DigitalData(digitalData);
